const ReportTemplateReformatCopyData = (listRawData) => {
  const _list = [];
  for (let rawData of listRawData) {
    const row = {};

    if (rawData.data_kendaraan) {
      row["nomor_polisi"] = rawData.data_kendaraan.nomor_polisi;
      row["jenis_mobil"] = rawData.data_kendaraan.jenis_mobil;
      row["tahun_mobil"] = rawData.data_kendaraan.tahun;
      row["tanggal"] = rawData.tanggal;
      row["group"] = rawData.label_grup;
      row["keterangan"] = rawData.keterangan;

      _list.push(row);
    }
  }
  return _list;
};

export default ReportTemplateReformatCopyData;
